import { useEffect, useState } from 'react';
import { getMyAiUsage } from '../api/endpointsBackend';
import { AI_USED_EVENT } from '../utils/aiUsage';

// The share of today's and this month's AI budget the signed-in person has
// used (MI-354). Read when it mounts, again when the window regains focus, and
// after every paid AI call the API client sees succeed (AI_USED_EVENT). A read
// again that fails keeps what the last one found.
export default function useAiUsage() {
  const [state, setState] = useState({ usage: null, loading: true, error: null });

  useEffect(() => {
    let alive = true;
    // Through a promise, so a test that mocks the API without this call
    // reads as "no usage" instead of throwing.
    const read = () => Promise.resolve()
      .then(() => getMyAiUsage())
      .then((usage) => alive && setState({ usage, loading: false, error: null }))
      .catch((error) => alive && setState((prev) => (
        prev.usage ? { ...prev, loading: false } : { usage: null, loading: false, error }
      )));
    read();
    window.addEventListener('focus', read);
    window.addEventListener(AI_USED_EVENT, read);
    return () => {
      alive = false;
      window.removeEventListener('focus', read);
      window.removeEventListener(AI_USED_EVENT, read);
    };
  }, []);

  return state;
}
